import { Link, Modal, Text } from "@shopify/polaris"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

interface UpdateURLModalProps {
  open: boolean
  onClose: () => void
  onUpdate: () => void
  loading?: boolean
  /** 阻止点击蒙版关闭弹窗 */
  preventCloseOnClickOutside?: boolean
}

// 全局样式ID，用于识别动态创建的style标签
const GLOBAL_STYLE_ID = "updateURLModal-prevent-button-pressed"

export const UpdateURLModal: React.FC<UpdateURLModalProps> = ({
  open,
  onClose,
  onUpdate,
  loading = false,
  preventCloseOnClickOutside = false,
}) => {
  const { t } = useTranslation(["tracking_page", "common"])

  // 使用useEffect监听蒙层点击事件
  useEffect(() => {
    if (!preventCloseOnClickOutside || !open) return

    const handleBackdropClick = (event: Event) => {
      const target = event.target as HTMLElement

      // 检查是否点击的是Polaris蒙层
      if (target && target.classList.contains("Polaris-Backdrop")) {
        event.stopPropagation()
        event.preventDefault()
      }
    }

    // 延迟添加事件监听器，确保Modal已经渲染
    const timer = setTimeout(() => {
      document.addEventListener("click", handleBackdropClick, true)
    }, 0)

    return () => {
      clearTimeout(timer)
      document.removeEventListener("click", handleBackdropClick, true)
    }
  }, [preventCloseOnClickOutside, open])

  // 使用useEffect动态创建/移除全局样式
  useEffect(() => {
    if (!open || !preventCloseOnClickOutside) {
      // 移除全局样式
      const existingStyle = document.getElementById(GLOBAL_STYLE_ID)

      if (existingStyle) {
        existingStyle.remove()
      }
      return
    }

    // 创建全局样式
    const styleElement = document.createElement("style")

    styleElement.id = GLOBAL_STYLE_ID
    styleElement.textContent = `
      .Polaris-Button--pressed {
        background: none;
      }
    `

    // 添加到head中
    document.head.appendChild(styleElement)

    return () => {
      // 清理时移除样式
      const existingStyle = document.getElementById(GLOBAL_STYLE_ID)

      if (existingStyle) {
        existingStyle.remove()
      }
    }
  }, [preventCloseOnClickOutside, open])

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("tracking_page:UpdateOldURL")}
      primaryAction={{
        content: t("tracking_page:Update"),
        onAction: onUpdate,
        loading: loading,
      }}
    >
      <Modal.Section>
        <Text as="p" variant="bodyMd" fontWeight={"medium"}>
          {t("tracking_page:SystemDetectedOldURL")}
        </Text>
        <div className="mt-3" />
        <Text as="p" variant="bodyMd">
          {t("tracking_page:UpdateOldURLText")}
        </Text>
        <div className="mt-1" />
        <Text as="p" variant="bodyMd" tone="subdued">
          {t("tracking_page:UpdateOldURLDoc")}{" "}
          <Link
            url="https://docs.parcelpanel.com/shopify/notifications/add-tracking-link-shopify/"
            target="_blank"
            removeUnderline
            external
          >
            {t("tracking_page:HowAddTrackingLink")}
          </Link>
        </Text>
      </Modal.Section>
    </Modal>
  )
}
